<template>
    <div class="main">
        <VideoList v-if="!isIOS" :dataList="dataList"></VideoList>
        <VideoList_xgp v-else :dataList="dataList"></VideoList_xgp>
    </div>
</template>

<script>
import VideoList from "../components/VideoList.vue"
import VideoList_xgp from "../components/VideoList_xgp.vue"

import { get_moreVideo } from "../util/api";
import { browser } from "../util/video_article";


export default {
    components: {
        VideoList,
        VideoList_xgp
    },
    data() {
        return {
            isIOS: browser.versions.ios,
            dataList: []
        }
    },
    async created() {
        // 首先假如第一个data
        this.dataList.push({
            id: window.article_info.id,
            title: window.article_info.title,
            des: window.article_info.des,
            channelId: window.article_info.channelId,
            url: window.article_info.url,
            from: window.article_info.from,
            poster: window.article_info.poster,
            headerimg: window.article_info.headerimg,
            jianjielink: window.article_info.jianjielink,
            sharetext: window.article_info.sharetext,
            clicknum: window.article_info.clicknum,
            publishDate: window.article_info.publishDate,
        })
        const arr = await this.getInfo();
        // 重新生成数据
        this.dataList = [...this.dataList, ...arr];
        console.log(this.dataList)
    },
    methods: {
        async getInfo() {

            return await get_moreVideo(window.article_info.channelId)
        }
    }
}
</script>